module.exports = __webpack_public_path__ + "static/img/l_cymnsxt.34b806d4.png";